import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import { Button, Row, Col, Form, Spinner } from "react-bootstrap";
import { CustomTable, CustomVerification, DropdownFilter, MultiSelectFilter } from "./styled";

import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { Sidebar } from "primereact/sidebar";

import {
    integrationGetDisciplineList,
    integrationGetObjectList,
    integrationGetUnityThemeList,
    integrationMaterialsList,
    integrationProjectList,
} from "../../../../../services/integration.service";
import { HiOutlineArrowCircleLeft } from "react-icons/hi";
import { CategoryIcon } from "../../../manager-dashboard/styles";
import { listObjectType } from "../../../../../services/filters.service";
import { ObjectsCategoryIcon } from "../../../styled";

export function ModalImportProduct(props: any) {
    const { t: translation } = useTranslation();
    const { handleHideModal, onImport, show, submitButtonText, loading } = props;

    const [importStage, setImportStage] = useState(2);

    const materialTypeOptions = [
        { label: "Disciplina", value: "disciplina" },
        { label: "Unidade", value: "unidade" },
        { label: "Tema", value: "tema" },
        { label: "Objeto", value: "objeto" },
    ];

    // List
    const [projectList, setProjectList] = useState([]);
    const [disciplineList, setDisciplineList] = useState([]);
    const [materialsList, setMaterialList] = useState([]);
    const [objectsList, setObjectsList] = useState<any>([]);
    const [categoryList, setCategoryList] = useState([]);

    const [pendentMediasList, setPendentMediasList] = useState<any>([]);

    // lazy-load itens do select
    const [pagesLoaded, setPagesLoaded] = useState(0);
    const [hasMorePages, setHasMorePages] = useState(true);
    const [selectItemsLoading, setSelectItemsLoading] = useState(false);
    const disciplineSelectRef = useRef(null);
    const unitSelectRef = useRef(null);
    const themeSelectRef = useRef(null);
    const objectSelectRef = useRef<MultiSelect>(null);
    // -----

    //Objects
    const [projectSelected, setProjectSelected] = useState<any>({});
    const [disciplinesSelected, setDisciplinesSelected] = useState<any>([]);
    const [itemsSelected, setItemsSelected] = useState<any>([]);
    const [themesSelected, setThemesSelected] = useState<any>([]);
    const [mediasSelected, setMediasSelected] = useState<any>([]);
    const [categorySelected, setCategorySelected] = useState<any>([]);

    const [materialTypeSelected, setMaterialTypeSelected] = useState<any>({});
    const [disableMaterialType, setDisableMaterialType] = useState<boolean>(true);
    const [showDisciplineField, setShowDisciplineField] = useState<boolean>(false);
    const [showUnityField, setShowUnityField] = useState<boolean>(false);
    const [showThemeField, setShowThemeField] = useState<boolean>(false);
    const [showObjectField, setShowObjectField] = useState<boolean>(false);

    useEffect(() => {
        integrationProjectList().then((resp) => {
            setProjectList(resp);
        });

        listObjectType().then((data) => setCategoryList(data));
    }, []);

    useEffect(() => {
        if (loading === false) {
            handleCloseModal();
        }
    }, [loading]);

    useEffect(() => {
        if (projectSelected.id) {
            setDisciplinesSelected(undefined);
            handleClearMaterias();
            setMaterialTypeSelected({});
            setMaterialList([]);
            setObjectsList([]);
        }
    }, [projectSelected]);

    /**
     * ao selecionar o tipo de material a ser importado,
     * esconde todos os campos e mostra somente os relevantes ao tipo especificado
     * carrega a lista de materias do tipo especificado
     * reseta o numero de paginas de lazy load carregadas
     */
    useEffect(() => {
        setShowDisciplineField(false);
        setShowUnityField(false);
        setShowThemeField(false);
        setShowObjectField(false);

        setPagesLoaded(0);
        setHasMorePages(true);

        if (materialTypeSelected === "disciplina") {
            setShowDisciplineField(true);
            setShowUnityField(true);
            setShowObjectField(true);

            getDisciplines();
        }

        if (materialTypeSelected === "unidade") {
            setShowUnityField(true);
            setShowObjectField(true);
            getUnities();
        }
        if (materialTypeSelected === "tema") {
            setShowThemeField(true);
            setShowObjectField(true);
            getThemes();
        }
        if (materialTypeSelected === "objeto") {
            setShowObjectField(true);
            getObjects();
        }
    }, [materialTypeSelected]);

    useEffect(() => {
        if (disciplinesSelected && disciplinesSelected.length > 0) {
            var _disciplineList = disciplinesSelected.map((disc: any) => {
                return disc.id;
            });

            integrationMaterialsList({
                materials: _disciplineList,
                material_type: "discipline",
                category: categorySelected,
            }).then((resp) => {
                var itemsList: any[] = [];
                var _objectsList: any[] = [];

                resp.map((obj: any) => {
                    itemsList = [...itemsList, ...obj.items];

                    obj.items.map((item: any) => {
                        _objectsList = [..._objectsList, ...item.medias];
                    });
                });

                setMaterialList(resp);
                setItemsSelected(itemsList);

                if (materialTypeSelected === "objeto") {
                    setObjectsList(_objectsList);
                    setMediasSelected(_objectsList);
                }
            });
        }
    }, [disciplinesSelected, categorySelected]);

    useEffect(() => {
        if (materialTypeSelected === "unidade") {
            var unitiesList = itemsSelected.map((disc: any) => {
                return disc.id;
            });
            integrationMaterialsList({
                materials: unitiesList,
                material_type: "item",
                category: categorySelected,
            }).then((resp) => {
                var _objectsList: any[] = [];

                resp.map((obj: any) => {
                    _objectsList = [..._objectsList, ...obj.medias];
                });

                setObjectsList(resp);
                setMediasSelected(_objectsList);
            });
        } else if (materialTypeSelected === "tema") {
            var themesList = themesSelected.map((disc: any) => {
                return disc.id;
            });
            integrationMaterialsList({
                materials: themesList,
                material_type: "theme",
                category: categorySelected,
            }).then((resp) => {
                var _objectsList: any[] = [];

                resp.map((obj: any) => {
                    _objectsList = [..._objectsList, ...obj.medias];
                });

                setObjectsList(resp);
                setMediasSelected(_objectsList);
            });
        } else {
            var _objectList = [...itemsSelected];
            setObjectsList(_objectList);

            if (_objectList) {
                var mediaList: any[] = [];
                _objectList.forEach((items: any) => {
                    mediaList = [...mediaList, ...items.medias];
                });
                setMediasSelected(mediaList);
            }
        }
    }, [itemsSelected, themesSelected, categorySelected]);

    /**
     * scroll observer do select que terá lazy-load
     * inicia um novo carregamento quando este chegar ao threshold
     */
    const handleSelectScroll: EventListener = (event) => {
        let target = event.target as HTMLDivElement;
        let targetMaxHeight = parseInt(target.style.maxHeight.split(`px`)[0]) ?? 0;

        let scrollPercentage = target.scrollTop / (target.scrollHeight - targetMaxHeight);

        if (scrollPercentage > 0.8) {
            // ver se existe uma próxima página a ser carregada
            // ver se já existe algo carregando
            if (hasMorePages && !selectItemsLoading) {
                // colocar a próxima página para carregar
                setSelectItemsLoading(true);
            }
        }
    };

    /**
     * Método chamado pelo MultiSelect ao abrir o overlay
     * adiciona um eventlistener no scroll da lista de itens
     * @param name o nome do select que invocou o método
     */
    const checkIfLazyloaded = (name: string) => {
        // if (name == materialTypeSelected) {

        // por enquanto só lazy load nos objetos
        if (name == "objeto") {
            // ajustar para pegar a Ref do select com base no nome quando implementado para outros tipos de material
            // o overlay só existe enquanto o select está aberto, então esse event listener não precisa ser removido
            objectSelectRef.current
                ?.getOverlay()
                ?.querySelector(`.p-multiselect-items-wrapper`)
                ?.addEventListener(`scroll`, handleSelectScroll);
        }
    };

    const handleClearMaterias = () => {
        setItemsSelected([]);
        setThemesSelected([]);
        setMediasSelected([]);

        setPagesLoaded(0);
        setHasMorePages(true);
    };

    const handleCloseModal = () => {
        setProjectSelected({});
        setMaterialTypeSelected({});
        setCategorySelected([]);
        setDisciplinesSelected([]);
        handleClearMaterias();
        setDisableMaterialType(true);
        setShowDisciplineField(false);
        setShowUnityField(false);
        setShowThemeField(false);
        setShowObjectField(false);
        setImportStage(1);
        handleHideModal();
    };

    const handleImport = () => {
        if (importStage === 1) {
            const pendentList = checkMediaPendency();
            if (pendentList.length > 0) {
                setPendentMediasList(pendentList);
                setImportStage(2);
            } else {
                setImportStage(3);
            }
        }
        if (importStage === 2) {
            setImportStage(3);
        }
        if (importStage === 3) {
            var _disciplineList = disciplinesSelected
                ? disciplinesSelected.map((disc: any) => {
                      return disc.id;
                  })
                : [];
            var itemList = itemsSelected
                ? itemsSelected.map((item: any) => {
                      return item.id;
                  })
                : [];
            var themeList = themesSelected
                ? themesSelected.map((theme: any) => {
                      return theme.id;
                  })
                : [];
            var mediaList = mediasSelected
                ? mediasSelected
                      .filter((media: any) => media.pendecy === false || media.pendency === false)
                      .map((media: any) => {
                          return media.id;
                      })
                : [];

            var payload = {
                disciplines: _disciplineList,
                themes: themeList,
                items: itemList,
                medias: mediaList,
            };
            onImport(payload);
        }
    };

    const checkMediaPendency = () => {
        var pendentMedias: any[] = [];
        if (mediasSelected.length) {
            mediasSelected.map((obj: any) => {
                if (obj.pendecy || obj.pendency) {
                    pendentMedias.push(obj);
                }
            });
        }
        return pendentMedias;
    };

    const handleChangeMaterialType = (value: string) => {
        handleClearMaterias();
        setDisciplinesSelected(undefined);
        setMaterialList([]);
        setObjectsList([]);
        setMaterialTypeSelected(value);
    };

    const getDisciplines = () => {
        integrationGetDisciplineList(projectSelected.id).then((disciplines: any) => {
            setDisciplineList(disciplines);
        });
    };

    const getUnities = () => {
        const params = {
            material: "item",
        };
        integrationGetUnityThemeList(projectSelected.id, params).then((unities: any) => {
            setMaterialList(unities);
        });
    };

    const getThemes = () => {
        const params = {
            material: "theme",
        };
        integrationGetUnityThemeList(projectSelected.id, params).then((themes: any) => {
            setMaterialList(themes);
        });
    };

    // carregar a listagem de objetos
    const getObjects = () => {
        if (hasMorePages) {
            integrationGetObjectList(projectSelected.id, pagesLoaded + 1, categorySelected)
                .then((objects) => {
                    setPagesLoaded(pagesLoaded + 1);
                    setHasMorePages(objects.next?.length > 0);

                    setObjectsList([...objectsList, ...objects.results]);
                })
                .finally(() => {
                    setSelectItemsLoading(false);
                });
        }
    };

    // gatilho para o lazy loading do select
    useEffect(() => {
        if (selectItemsLoading) {
            if (materialTypeSelected === "objeto") {
                getObjects();
            }
        }
    }, [selectItemsLoading]);

    const optionGroupTemplateUnity = (opt: any) => {
        return (
            <>
                <p className={opt.items.length > 0 ? "mb-0" : ""}>{opt.name ? opt.name : opt.title}</p>
                {opt.items.length === 0 && <p className="empty-message-opt-group">Nenhuma unidade encontrada</p>}
            </>
        );
    };

    const optionGroupTemplateTheme = (opt: any) => {
        return (
            <>
                <p className={opt.items.length > 0 ? "mb-0" : ""}>{opt.name ? opt.name : opt.title}</p>
                {opt.items.length === 0 && <p className="empty-message-opt-group">Nenhum tema encontrado</p>}
            </>
        );
    };

    const optionGroupTemplateObject = (opt: any) => {
        return (
            <>
                <p className={opt.medias.length > 0 ? "mb-0" : ""}>{opt.name ? opt.name : opt.title}</p>
                {opt.medias.length === 0 && <p className="empty-message-opt-group">Nenhum objeto encontrado</p>}
            </>
        );
    };

    const optioItemTemplateObject = (option: any) => {
        console.log(option);

        if (option.icon) {
            return (
                <div>
                    <CategoryIcon
                        style={{
                            textAlign: "left",
                            color: "#747474",
                            marginRight: "5px",
                            fontSize: "20px",
                            verticalAlign: "middle",
                        }}
                        className={`material-icons-${option.icon}`}
                    >
                        {option.icon.split(" ")[1]}
                    </CategoryIcon>
                    {option.name}
                </div>
            );
        }

        return (
            <div>
                <CategoryIcon
                    style={{
                        textAlign: "left",
                        color: "#747474",
                        marginRight: "5px",
                        fontSize: "20px",
                        verticalAlign: "middle",
                    }}
                    className={`material-icons-outlined sticky_note_2`}
                >
                    sticky_note_2
                </CategoryIcon>
                {option.name}
            </div>
        );
    };

    const categoryTemplate = (option: any) => {
        return (
            <div>
                <ObjectsCategoryIcon
                    style={{ textAlign: "left", verticalAlign: "bottom", color: "#606060" }}
                    className={`material-icons-${option.category_icon}`}
                >
                    {option.category_icon.split(" ")[1]}
                </ObjectsCategoryIcon>
                <span style={{ verticalAlign: "text-bottom", marginLeft: "5px" }}>{option.title}</span>
            </div>
        );
    };

    return (
        <Sidebar
            {...props}
            visible={show}
            onHide={handleCloseModal}
            position="right"
            blockScroll
            dismissable={false}
            className="p-sidebar-md"
        >
            <h4 className="sidebar-import-header">
                {importStage > 1 && (
                    <span>
                        <HiOutlineArrowCircleLeft className="mr-1 cursor-pointer" onClick={() => setImportStage(1)} />
                    </span>
                )}
                Importar material
            </h4>

            <div className="sidebar-import-content" style={{ overflowX : "hidden"}}>
                {importStage === 1 ? (
                    <>
                        <Form>
                            <Row>
                                <Col sm={12} className="mb-3">
                                    <Form.Group>
                                        <Form.Label>Projeto</Form.Label>
                                        <DropdownFilter>
                                            <Dropdown
                                                optionLabel="name"
                                                value={projectSelected}
                                                filter
                                                appendTo="self"
                                                options={projectList}
                                                onChange={(e: any) => {
                                                    setProjectSelected(e.value);
                                                    setDisableMaterialType(false);
                                                }}
                                                placeholder={translation("manager.labels.import.select_project")}
                                            />
                                        </DropdownFilter>
                                    </Form.Group>
                                </Col>

                                <Col sm={12} className="mb-3">
                                    <Form.Group>
                                        <Form.Label>Categoria</Form.Label>
                                        <MultiSelectFilter>
                                            <MultiSelect
                                                maxSelectedLabels={-1}
                                                selectedItemsLabel={"{0} " + translation("filters.selectedLabel")}
                                                value={categorySelected}
                                                appendTo="self"
                                                optionLabel="title"
                                                optionValue="id"
                                                placeholder={translation("manager.labels.import.select_category")}
                                                className="multiselect-dropdown ds-select"
                                                options={categoryList}
                                                onChange={(event: any) => setCategorySelected(event.value)}
                                                itemTemplate={categoryTemplate}
                                                filter
                                            />
                                        </MultiSelectFilter>
                                    </Form.Group>
                                </Col>

                                <Col sm={12} className="mb-3">
                                    <Form.Group>
                                        <Form.Label>Selecionar tipo do material</Form.Label>
                                        <DropdownFilter>
                                            <Dropdown
                                                value={materialTypeSelected}
                                                disabled={disableMaterialType}
                                                options={materialTypeOptions}
                                                onChange={(e: any) => handleChangeMaterialType(e.value)}
                                                placeholder={translation("manager.labels.materialType")}
                                            />
                                        </DropdownFilter>
                                    </Form.Group>
                                </Col>

                                {/* -------***--------- */}
                                {/* Select das Disciplinas */}
                                {/* -------***--------- */}

                                {showDisciplineField && (
                                    <Col xs={12} className="mb-3">
                                        <Form.Group>
                                            <Form.Label>Disciplina</Form.Label>
                                            <MultiSelectFilter>
                                                <MultiSelect
                                                    ref={disciplineSelectRef}
                                                    maxSelectedLabels={-1}
                                                    selectedItemsLabel={"{0} " + translation("filters.selectedLabel")}
                                                    value={disciplinesSelected}
                                                    appendTo="self"
                                                    optionLabel="name"
                                                    disabled={projectSelected?.id ? false : true}
                                                    placeholder={translation("manager.labels.import.select_discipline")}
                                                    className="multiselect-dropdown ds-select"
                                                    options={disciplineList}
                                                    onChange={(event: any) => setDisciplinesSelected(event.value)}
                                                    filter
                                                    onShow={() => {
                                                        checkIfLazyloaded("disciplina");
                                                    }}
                                                />
                                            </MultiSelectFilter>
                                        </Form.Group>
                                    </Col>
                                )}

                                {/* -------***--------- */}
                                {/* Select das Unidades */}
                                {/* -------***--------- */}

                                {showUnityField && (
                                    <Col xs={12} className="mb-3">
                                        <Form.Group>
                                            <Form.Label>Unidade</Form.Label>
                                            <MultiSelectFilter>
                                                <MultiSelect
                                                    ref={unitSelectRef}
                                                    maxSelectedLabels={-1}
                                                    selectedItemsLabel={"{0} " + translation("filters.selectedLabel")}
                                                    value={itemsSelected}
                                                    appendTo="self"
                                                    optionLabel="name"
                                                    optionGroupChildren={"items"}
                                                    optionGroupTemplate={optionGroupTemplateUnity}
                                                    optionGroupLabel={
                                                        materialTypeSelected !== "unidade" ? "title" : "name"
                                                    }
                                                    disabled={materialsList?.length > 0 ? false : true}
                                                    placeholder={translation("manager.labels.import.select_item")}
                                                    className="multiselect-dropdown ds-select"
                                                    options={materialsList}
                                                    onChange={(event: any) => setItemsSelected(event.value)}
                                                    filter
                                                    onShow={() => {
                                                        checkIfLazyloaded("unidade");
                                                    }}
                                                />
                                            </MultiSelectFilter>
                                        </Form.Group>
                                    </Col>
                                )}

                                {/* -------***--------- */}
                                {/* Select dos Temas  */}
                                {/* -------***--------- */}

                                {showThemeField && (
                                    <Col xs={12} className="mb-3">
                                        <Form.Group>
                                            <Form.Label>Tema</Form.Label>
                                            <MultiSelectFilter>
                                                <MultiSelect
                                                    ref={themeSelectRef}
                                                    maxSelectedLabels={-1}
                                                    selectedItemsLabel={"{0} " + translation("filters.selectedLabel")}
                                                    value={themesSelected}
                                                    appendTo="self"
                                                    optionLabel="name"
                                                    optionGroupLabel="name"
                                                    optionGroupChildren={"items"}
                                                    optionGroupTemplate={optionGroupTemplateTheme}
                                                    disabled={materialsList?.length > 0 ? false : true}
                                                    placeholder={translation("manager.labels.import.select_theme")}
                                                    className="multiselect-dropdown ds-select"
                                                    options={materialsList}
                                                    onChange={(event: any) => setThemesSelected(event.value)}
                                                    filter
                                                />
                                            </MultiSelectFilter>
                                        </Form.Group>
                                    </Col>
                                )}

                                {/* -------***--------- */}
                                {/* Select dos Objetos  */}
                                {/* -------***--------- */}

                                {showObjectField && (
                                    <Col xs={12} className="mb-3">
                                        <Form.Group>
                                            <Form.Label>Objetos</Form.Label>
                                            <MultiSelectFilter>
                                                <MultiSelect
                                                    ref={objectSelectRef}
                                                    maxSelectedLabels={-1}
                                                    selectedItemsLabel={"{0} " + translation("filters.selectedLabel")}
                                                    value={mediasSelected}
                                                    appendTo="self"
                                                    optionLabel="name"
                                                    optionGroupLabel={
                                                        materialTypeSelected === "unidade" ||
                                                        materialTypeSelected === "tema"
                                                            ? "title"
                                                            : "name"
                                                    }
                                                    optionGroupChildren={"medias"}
                                                    optionGroupTemplate={optionGroupTemplateObject}
                                                    itemTemplate={optioItemTemplateObject}
                                                    disabled={objectsList?.length > 0 ? false : true}
                                                    placeholder={translation("manager.labels.import.select_object")}
                                                    className="multiselect-dropdown ds-select"
                                                    options={objectsList}
                                                    onChange={(event: any) => setMediasSelected(event.value)}
                                                    filter
                                                    onShow={() => {
                                                        checkIfLazyloaded("objeto");
                                                    }}
                                                />
                                            </MultiSelectFilter>
                                        </Form.Group>
                                    </Col>
                                )}
                            </Row>
                        </Form>
                    </>
                ) : (
                    <></>
                )}

                {importStage === 2 ? (
                    <>
                        <Row>
                            <Col style={{ fontSize: "14px" }}>
                                <p style={{ fontSize: "16px" }}> Não é possível importar os seguintes objetos. </p>
                                <p>
                                    Os objetos não serão importados, pois o sistema só permite a importação de objetos
                                    com um único arquivo. Para importá-los verifique-os na Deduca.
                                </p>
                                <p>
                                    Se você deseja importar o restante dos materiais selecionados anteriormente, clique
                                    em continuar.
                                </p>
                            </Col>
                        </Row>

                        <CustomTable>
                            <Row className="tableHeader mb-2">
                                <Col>Objeto</Col>
                                <Col>Unidade/Tema</Col>
                                <Col>Disciplina</Col>
                            </Row>

                            {!!pendentMediasList &&
                                pendentMediasList.map((obj: any, index: any) => (
                                    <Row className="tableCard mb-2">
                                        <Col>{obj.name}</Col>
                                        <Col className="secondaryTitle">{obj?.item_name}</Col>
                                        <Col className="secondaryTitle">{obj?.discipline_name}</Col>
                                    </Row>
                                ))}
                        </CustomTable>
                    </>
                ) : (
                    <></>
                )}

                {importStage === 3 ? (
                    <>
                        <Row>
                            <Col>
                                <p>Somente os materiais abaixo serão importados.</p>
                            </Col>
                        </Row>

                        <CustomVerification>
                            <>
                                {materialTypeSelected === "disciplina" ? (
                                    <>
                                        {!!disciplinesSelected &&
                                            disciplinesSelected?.map((discipline: any, index: any) => (
                                                <>
                                                    <Row className="tableCard mb-1">
                                                        <Col>{discipline.name}</Col>
                                                    </Row>

                                                    {!!itemsSelected &&
                                                        itemsSelected?.map((item: any, index_item: any) => (
                                                            <>
                                                                {item.discipline === discipline.name ? (
                                                                    <>
                                                                        <Row className="tableCard card-item mb-1">
                                                                            <Col>{item.name}</Col>
                                                                        </Row>

                                                                        {mediasSelected &&
                                                                            mediasSelected?.map(
                                                                                (media: any, index_media: any) => {
                                                                                    return (
                                                                                        <>
                                                                                            {!media.pendecy &&
                                                                                            media.item_name ===
                                                                                                item.name ? (
                                                                                                <Row className="tableCard card-media mb-1">
                                                                                                    <Col>
                                                                                                        {media.name}
                                                                                                    </Col>
                                                                                                </Row>
                                                                                            ) : (
                                                                                                <></>
                                                                                            )}
                                                                                        </>
                                                                                    );
                                                                                }
                                                                            )}
                                                                    </>
                                                                ) : (
                                                                    <></>
                                                                )}
                                                            </>
                                                        ))}
                                                </>
                                            ))}
                                    </>
                                ) : (
                                    <>
                                        {materialTypeSelected === "unidade" &&
                                            itemsSelected &&
                                            itemsSelected?.map((item: any, index_item: any) => (
                                                <>
                                                    <Row className="tableCard card-item mb-1">
                                                        <Col>{item.name}</Col>
                                                    </Row>

                                                    {mediasSelected &&
                                                        mediasSelected?.map((media: any, index_media: any) => {
                                                            return (
                                                                <>
                                                                    {!media.pendecy && media.item_name === item.name ? (
                                                                        <Row className="tableCard card-media mb-1">
                                                                            <Col>{media.name}</Col>
                                                                        </Row>
                                                                    ) : (
                                                                        <></>
                                                                    )}
                                                                </>
                                                            );
                                                        })}
                                                </>
                                            ))}

                                        {materialTypeSelected === "tema" &&
                                            themesSelected &&
                                            themesSelected?.map((theme: any, index_item: any) => (
                                                <>
                                                    <Row className="tableCard card-theme mb-1">
                                                        <Col>{theme.name}</Col>
                                                    </Row>

                                                    {mediasSelected &&
                                                        mediasSelected?.map((media: any, index_media: any) => {
                                                            return (
                                                                <>
                                                                    {!media.pendecy &&
                                                                    media.item_name === theme.name ? (
                                                                        <Row className="tableCard card-media mb-1">
                                                                            <Col>{media.name}</Col>
                                                                        </Row>
                                                                    ) : (
                                                                        <></>
                                                                    )}
                                                                </>
                                                            );
                                                        })}
                                                </>
                                            ))}

                                        {materialTypeSelected === "objeto" &&
                                            mediasSelected &&
                                            mediasSelected?.map((media: any, index_media: any) => {
                                                return (
                                                    <>
                                                        {!media.pendecy ? (
                                                            <Row className="tableCard card-media mb-1">
                                                                <Col>{media.name}</Col>
                                                            </Row>
                                                        ) : (
                                                            <></>
                                                        )}
                                                    </>
                                                );
                                            })}
                                    </>
                                )}
                            </>
                        </CustomVerification>
                    </>
                ) : (
                    <></>
                )}
            </div>

            <div className="sidebar-import-footer">
                <div className="d-flex justify-content-between">
                    <Button className="mt-3" variant="outline-primary" onClick={() => handleCloseModal()}>
                        {translation("cancel")}
                    </Button>
                    {onImport && (
                        <>
                            {loading ? (
                                <>
                                    <div className="loading-container mt-3">
                                        <Spinner
                                            animation="border"
                                            variant="primary"
                                            style={{
                                                width: "2rem",
                                                height: "2rem",
                                                borderWidth: "0.25em",
                                                borderRightColor: "transparent",
                                            }}
                                        />
                                    </div>
                                </>
                            ) : (
                                <>
                                    <Button className="mt-3" type="button" onClick={() => handleImport()}>
                                        {importStage === 2 ? translation("lead.continue") : submitButtonText}
                                    </Button>
                                </>
                            )}
                        </>
                    )}
                </div>
            </div>
        </Sidebar>
    );
}
